// extracted by mini-css-extract-plugin
export var postImage = "style-module--post-image--a9540";
export var postImage__image = "style-module--post-image__image--e4c62";